import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Grid } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import navigationConfig from "configs/NavigationConfig";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from 'utils'
import { onMobileNavToggle } from "redux/actions/Theme";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;
let listaMenu = []
let listaMenuSupervisor = []
let listaMenuReportes = []
let listaMenuProcess = []

for (let i = 0; i < navigationConfig.length; i++) {
  if (i < 24){
    listaMenu.push(navigationConfig[i])
  }
}

for (let j = 0; j < navigationConfig.length; j++) {
  if (j > 23 && j < 40){
    listaMenuSupervisor.push(navigationConfig[j])
  }  
}

for (let k = 0; k < navigationConfig.length; k++) {
  if (k > 39 && k < 46) {
    listaMenuReportes.push(navigationConfig[k])
  }
  if (k > 45){
    listaMenuProcess.push(navigationConfig[k])
  }
}

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
	const { sideNavTheme, routeInfo, hideGroupTitle, localization, onMobileNavToggle } = props;
  const [ listMenu , setListMenu] = useState([])
  let role = ''
	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
	const closeMobileNav = () => {
		if (isMobile) {
			onMobileNavToggle(false)
		}
	}

  useEffect(() => {
    role = localStorage.getItem('user')
    if(role === 'super_admin_role'){
      setListMenu(listaMenu)
    }else if (role === 'reporte_role'){
      setListMenu(listaMenuReportes)
    }else if (role === 'view_process'){
      setListMenu(listaMenuProcess)
    }else{
      setListMenu(listaMenuSupervisor)
    }
  }, [])
  

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {
        role === 'super_admin_role' ?
        listMenu.map((menuSupervisor) =>
          menuSupervisor.submenu.length > 0 ? (
            <Menu.ItemGroup
              key={menuSupervisor.key}
              title={setLocale(localization, menuSupervisor.title)}
            >
              {menuSupervisor.submenu.map((subMenuFirst) =>
                subMenuFirst.submenu.length > 0 ? (
                  <SubMenu
                    icon={
                      subMenuFirst.icon ? (
                        <Icon type={subMenuFirst?.icon} />
                      ) : null
                    }
                    key={subMenuFirst.key}
                    title={setLocale(localization, subMenuFirst.title)}
                  >
                    {subMenuFirst.submenu.map((subMenuSecond) => (
                      <Menu.Item key={subMenuSecond.key}>
                        {subMenuSecond.icon ? (
                          <Icon type={subMenuSecond?.icon} />
                        ) : null}
                        <span>
                          {setLocale(localization, subMenuSecond.title)}
                        </span>
                        <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item key={subMenuFirst.key}>
                    {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                    <span>{setLocale(localization, subMenuFirst.title)}</span>
                    <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
                  </Menu.Item>
                )
              )}
            </Menu.ItemGroup>
          ) : (
            <Menu.Item key={menuSupervisor.key}>
              {menuSupervisor.icon ? <Icon type={menuSupervisor?.icon} /> : null}
              <span>{setLocale(localization, menuSupervisor?.title)}</span>
              {menuSupervisor.path ? <Link onClick={() => closeMobileNav()} to={menuSupervisor.path} /> : null}
            </Menu.Item>
          )
        )
        :
        role === 'reporte_role' ?
          listaMenuReportes.map((menuSupervisor) =>
            menuSupervisor.submenu.length > 0 ? (
              <Menu.ItemGroup
                key={menuSupervisor.key}
                title={setLocale(localization, menuSupervisor.title)}
              >
                {menuSupervisor.submenu.map((subMenuFirst) =>
                  subMenuFirst.submenu.length > 0 ? (
                    <SubMenu
                      icon={
                        subMenuFirst.icon ? (
                          <Icon type={subMenuFirst?.icon} />
                        ) : null
                      }
                      key={subMenuFirst.key}
                      title={setLocale(localization, subMenuFirst.title)}
                    >
                      {subMenuFirst.submenu.map((subMenuSecond) => (
                        <Menu.Item key={subMenuSecond.key}>
                          {subMenuSecond.icon ? (
                            <Icon type={subMenuSecond?.icon} />
                          ) : null}
                          <span>
                            {setLocale(localization, subMenuSecond.title)}
                          </span>
                          <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
                        </Menu.Item>
                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item key={subMenuFirst.key}>
                      {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                      <span>{setLocale(localization, subMenuFirst.title)}</span>
                      <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
                    </Menu.Item>
                  )
                )}
              </Menu.ItemGroup>
            ) : (
              <Menu.Item key={menuSupervisor.key}>
                {menuSupervisor.icon ? <Icon type={menuSupervisor?.icon} /> : null}
                <span>{setLocale(localization, menuSupervisor?.title)}</span>
                {menuSupervisor.path ? <Link onClick={() => closeMobileNav()} to={menuSupervisor.path} /> : null}
              </Menu.Item>
            )
          )
        :
        role === 'view_process' ?
        listaMenuProcess.map((menuSupervisor) =>
            menuSupervisor.submenu.length > 0 ? (
              <Menu.ItemGroup
                key={menuSupervisor.key}
                title={setLocale(localization, menuSupervisor.title)}
              >
                {menuSupervisor.submenu.map((subMenuFirst) =>
                  subMenuFirst.submenu.length > 0 ? (
                    <SubMenu
                      icon={
                        subMenuFirst.icon ? (
                          <Icon type={subMenuFirst?.icon} />
                        ) : null
                      }
                      key={subMenuFirst.key}
                      title={setLocale(localization, subMenuFirst.title)}
                    >
                      {subMenuFirst.submenu.map((subMenuSecond) => (
                        <Menu.Item key={subMenuSecond.key}>
                          {subMenuSecond.icon ? (
                            <Icon type={subMenuSecond?.icon} />
                          ) : null}
                          <span>
                            {setLocale(localization, subMenuSecond.title)}
                          </span>
                          <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
                        </Menu.Item>
                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item key={subMenuFirst.key}>
                      {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                      <span>{setLocale(localization, subMenuFirst.title)}</span>
                      <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
                    </Menu.Item>
                  )
                )}
              </Menu.ItemGroup>
            ) : (
              <Menu.Item key={menuSupervisor.key}>
                {menuSupervisor.icon ? <Icon type={menuSupervisor?.icon} /> : null}
                <span>{setLocale(localization, menuSupervisor?.title)}</span>
                {menuSupervisor.path ? <Link onClick={() => closeMobileNav()} to={menuSupervisor.path} /> : null}
              </Menu.Item>
            )
          )
        :listMenu.map((menuSupervisor) =>
          menuSupervisor.submenu.length > 0 ? (
            <Menu.ItemGroup
              key={menuSupervisor.key}
              title={setLocale(localization, menuSupervisor.title)}
            >
              {menuSupervisor.submenu.map((subMenuFirst) =>
                subMenuFirst.submenu.length > 0 ? (
                  <SubMenu
                    icon={
                      subMenuFirst.icon ? (
                        <Icon type={subMenuFirst?.icon} />
                      ) : null
                    }
                    key={subMenuFirst.key}
                    title={setLocale(localization, subMenuFirst.title)}
                  >
                    {subMenuFirst.submenu.map((subMenuSecond) => (
                      <Menu.Item key={subMenuSecond.key}>
                        {subMenuSecond.icon ? (
                          <Icon type={subMenuSecond?.icon} />
                        ) : null}
                        <span>
                          {setLocale(localization, subMenuSecond.title)}
                        </span>
                        <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item key={subMenuFirst.key}>
                    {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                    <span>{setLocale(localization, subMenuFirst.title)}</span>
                    <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
                  </Menu.Item>
                )
              )}
            </Menu.ItemGroup>
          ) : (
            <Menu.Item key={menuSupervisor.key}>
              {menuSupervisor.icon ? <Icon type={menuSupervisor?.icon} /> : null}
              <span>{setLocale(localization, menuSupervisor?.title)}</span>
              {menuSupervisor.path ? <Link onClick={() => closeMobileNav()} to={menuSupervisor.path} /> : null}
            </Menu.Item>
          )
        )
      }
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menuSupervisor) =>
        menuSupervisor.submenu.length > 0 ? (
          <SubMenu
            key={menuSupervisor.key}
            popupClassName="top-nav-menu"
            title={
              <span className="d-flex align-items-center">
                {menuSupervisor.icon ? <Icon type={menuSupervisor?.icon} /> : null}
                <span>{setLocale(localization, menuSupervisor.title)}</span>
              </span>
            }
          >
            {menuSupervisor.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  popupClassName="top-nav-menu"
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menuSupervisor.key}>
            {menuSupervisor.icon ? <Icon type={menuSupervisor?.icon} /> : null}
            <span>{setLocale(localization, menuSupervisor?.title)}</span>
            {menuSupervisor.path ? <Link to={menuSupervisor.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
